import { inject, Injectable } from '@angular/core';

import type { IConsentState } from 'src/services/personal-data-protection/types';
import { IS_EU_VISITOR } from 'src/shared/constants/is-eu-visitor/is-eu-visitor';

import { UC_SERVICE_TO_CONSENT_CAT, UC_SERVICES } from './entities/const';
import type { UserCentricsConsentEvent, UserCentricsServiceDescriptor } from './entities/types';

@Injectable({ providedIn: 'root' })
export class UserCentricsStateConvertorService {
    private readonly isEuVisitor = inject(IS_EU_VISITOR);

    public convert(data: UserCentricsServiceDescriptor[] | UserCentricsConsentEvent): IConsentState {
        if (this.isUserCentricsConsentEvent(data)) {
            return this.ucEventToState(data);
        }

        return this.ucStateToState(data);
    }

    private ucStateToState = (ucState: UserCentricsServiceDescriptor[]): IConsentState =>
        ucState.reduce((accumulator, item) => {
            accumulator[String(UC_SERVICE_TO_CONSENT_CAT[item.name])] = item.consent.status;
            return accumulator;
        }, {});

    private ucEventToState = (ucEvent: UserCentricsConsentEvent): any => {
        return Object.keys(ucEvent.detail)
            .filter((service) => Object.values(UC_SERVICES).indexOf(service as any) > -1)
            .reduce((accumulator, service) => {
                accumulator[String(UC_SERVICE_TO_CONSENT_CAT[service])] = ucEvent.detail[service];
                return accumulator;
            }, {});
    };

    private isUserCentricsConsentEvent(data): data is UserCentricsConsentEvent {
        return data.detail?.event === 'consent_status';
    }

    private isUserCentricsServiceDescriptor(data): data is UserCentricsServiceDescriptor {
        /* eslint-disable */
        return data.hasOwnProperty('consent');
    }
}
